import { useState, useRef } from "react";
import { parseWasteCSV } from "../constants/wasteData";

export function useWasteData(){
  const [wasteData,setWasteData]=useState([]);           // array of monthly records — see WASTE_CSV_HEADERS
  const [wasteDataConfig,setWasteDataConfig]=useState({}); // {unit,hasVolume,hasWeight,weightUnit}
  const [wasteUploadErrors,setWasteUploadErrors]=useState([]);
  const [wasteUploadSuccess,setWasteUploadSuccess]=useState("");
  const [wasteUploading,setWasteUploading]=useState(false);
  const wasteFileRef=useRef();

  // Validates then appends (never replaces) — all-or-nothing so a malformed file can't corrupt saved history
  const handleWasteUpload=async file=>{
    setWasteUploadErrors([]);setWasteUploadSuccess("");
    if(!file) return;
    const ext=file.name.split(".").pop().toLowerCase();
    if(ext!=="csv"){setWasteUploadErrors([`Please upload a .csv file (got .${ext}).`]);return;}
    setWasteUploading(true);
    try{
      const text=await file.text();
      const {records,errors}=parseWasteCSV(text);
      if(errors.length>0){
        setWasteUploadErrors(errors);
      }else{
        setWasteData(prev=>[...prev,...records]);
        setWasteUploadSuccess(`Added ${records.length} record${records.length!==1?"s":""} from ${file.name}.`);
      }
    }catch(e){
      console.error("handleWasteUpload",e);
      setWasteUploadErrors(["Could not read that file. Make sure it's a plain CSV export."]);
    }
    setWasteUploading(false);
  };

  return {
    wasteData,setWasteData,
    wasteDataConfig,setWasteDataConfig,
    wasteUploadErrors,wasteUploadSuccess,wasteUploading,
    wasteFileRef,
    handleWasteUpload,
  };
}
